import React from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap"
import StadisticCard from './StadisticCard';


function HomeStadistic(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    //const inputParam_ObjectMessageList = props.objectMessageList;
    const inputParam_ObjStadisticData = props.objStadisticData !== null && props.objStadisticData !== undefined ? props.objStadisticData : null;
    const inputParam_SelectedStadisticCard = props.selectedStadisticCard !== null && props.selectedStadisticCard !== undefined ? props.selectedStadisticCard : null;
    const inputParam_SetSelectedStadisticCard = props.setSelectedStadisticCard !== null && props.setSelectedStadisticCard !== undefined ? props.setSelectedStadisticCard : null;
    const inputParam_SetFireOrderData = props.setFireOrderData !== null && props.setFireOrderData !== undefined ? props.setFireOrderData : null;
    const inputParam_SetObjHomeStadisticData = props.setObjHomeStadisticData !== null && props.setObjHomeStadisticData !== undefined ? props.setObjHomeStadisticData : null;
    
    let sendedItemsList = 0;
    let receivedItemsList = 0;
    let pendingItemsList = 0;
    let expiredItemsList = 0;
    let unReadedItemsList = 0;

    let pendingWaiting = 0;
    let expiredWaiting = 0;
    let totalMessages = 0;
    
    if (inputParam_ObjStadisticData.data !== null) {
        for (let index = 0; index < inputParam_ObjStadisticData.data.length; index++) {
            const element = inputParam_ObjStadisticData.data[index];
        
            expiredItemsList = expiredItemsList += (element.expired_message);
            sendedItemsList = sendedItemsList += (element.sent_messages);
            receivedItemsList = receivedItemsList += (element.received_messages);
            unReadedItemsList = unReadedItemsList += (element.unread_message);
            pendingItemsList = pendingItemsList += (element.pending_messages);

            pendingWaiting = pendingWaiting += (element.pending_waiting_message);
            expiredWaiting = expiredWaiting += (element.expired_waiting_message);

            totalMessages = totalMessages += (element.total_messages);
            
        }
    }

    const container = {
        display: "flex",
        justifyContent: "center",
        margin: "0px",
        padding: "0px"
    };

    const cards = [
        { class: "col pt-2", title: t('data-lang-lbl-totalmessages'), type: "isTotalMessage", amount: (totalMessages), icon: "CreateMailRule", borderTop: "5px solid #a1a1a1", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-receivedmessages'), type: "isReceived", amount: receivedItemsList, icon: "Mail", borderTop: "5px solid #7FD7A7", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-sendedmessages'), type: "isSent", amount: sendedItemsList, icon: "Send", borderTop: "5px solid #A1B8E1", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-unreadedmessages'), type: "isUnread", amount: unReadedItemsList, icon: "MailAlert", borderTop: "5px solid #bdbd63", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-pendingmessages'), type: "isPending", amount: pendingItemsList, icon: "EventDateMissed12", borderTop: "5px solid #ffa97f", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-expiredmessages'), type: "isExpired", amount: expiredItemsList, icon: "Calories", borderTop: "5px solid #FF7F7F", display: true },

        { class: "col pt-2", title: t('data-lang-lbl-pendingwaiting'), type: "isPendingWaiting", amount: pendingWaiting, icon: "DateTime", borderTop: "5px solid #ffa97f", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-expiredwaiting'), type: "isExpiredWaiting", amount: expiredWaiting, icon: "Clock", borderTop: "5px solid #FF7F7F", display: true },
    ];

    return (
        <Card className='book-info-form'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>
                        { t('data-lang-boxname-stadisticbook') }
                    </b>
                    <div className='book-toolbar'>

                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body className='p-0 pb-2'>
                <Row style={ container }>
                    {
                        cards.map((card, index) => (
                            <div key={index} className={`${card.class} ${card.display ? "d-unset" : "d-none"}`} style={{cursor: "pointer", padding: "0px", minWidth: "120px"}} >
                                <StadisticCard
                                    item={ card }
                                    setSelectedStadisticCard={inputParam_SetSelectedStadisticCard}
                                    selectedStadisticCard={inputParam_SelectedStadisticCard}
                                    setFireOrderData={inputParam_SetFireOrderData}
                                    setObjHomeStadisticData={inputParam_SetObjHomeStadisticData} />
                            </div>
                        ))
                    }
                </Row>
            </Card.Body>
            <Card.Footer>

            </Card.Footer>
        </Card>


    );
}

export default HomeStadistic;

